import React, { useState } from "react";
import Logo from "../assets/SVGs/Logo";
import { Button, CircularProgress, TextField } from "@mui/material";
import { LoginAPI } from "../api/login";

const ForgotPassword = () => {
  const [form, setForm] = useState({ email: "" });
  const [formError, setFormError] = useState({ email: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const handleError = (formObj = form) => {
    const temp = { ...formError };

    if ("email" in formObj) {
      temp.email = formObj.email ? "" : "Email is required!";
    }

    setFormError({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    handleError({ [key]: value });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!handleError()) return;

    setIsLoading(true);
    setSubmitSuccess(false);
    setSubmitError("");

    try {
      await LoginAPI.forgot_password(form.email);
      setSubmitSuccess(true);
    } catch (error) {
      console.error(error);
      setSubmitError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex align-center justify-center login-container ">
      <div className="form-container flex align-center justify-center flex-col">
        <Logo />

        {!submitSuccess ? (
          <>
            <div className="flex align-center justify-center flex-col text-container">
              <h2>Forgot your password?</h2>
              <p>Enter your email to receive a reset link</p>
            </div>

            <div className="text-fleld-container flex flex-col">
              <TextField
                margin="normal"
                fullWidth
                id="email"
                label="Email*"
                name="email"
                autoComplete="email"
                autoFocus
                value={form.email}
                onChange={(e) => handleChange("email", e.target.value)}
                className="login-textField "
                onKeyUp={handleKeyPress}
                size="small"
                error={formError.email !== ""}
                helperText={formError.email}
              />
            </div>

            <Button
              type="submit"
              className="login-btn flex align-center justify-center"
              variant="contained"
              color="primary"
              disabled={isLoading}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <CircularProgress
                  sx={{
                    color: "#fff",
                    width: "20px!important",
                    height: "20px!important",
                  }}
                  disableShrink
                  variant="indeterminate"
                />
              ) : (
                "Send reset link"
              )}
            </Button>

            {submitError && <p className="error-message">{submitError}</p>}
          </>
        ) : (
          <div className="flex align-center justify-center flex-col text-container">
            <h2>Check your email</h2>
            <p>
              If <b>{form.email}</b> exists in our system, we&apos;ve sent a
              password reset link.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
